import { render } from "./AdminPanelView.vue?vue&type=template&id=11883d92&scoped=true"
import script from "./AdminPanelView.vue?vue&type=script&lang=js"
export * from "./AdminPanelView.vue?vue&type=script&lang=js"

import "./AdminPanelView.vue?vue&type=style&index=0&id=11883d92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11883d92"]])

export default __exports__